import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Organization } from '../../../../core/interfaces/organization';
import { OrganizationApiService } from '../../../../core/services/organization-api.service';
import { MessageService } from 'primeng/api';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { BlockUIModule } from 'primeng/blockui';
import { ToastModule } from 'primeng/toast';
import { InputTextComponent } from '../../../../shared/components/input-text/input-text.component';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-edit-organization',
  imports: [ButtonModule, 
            DialogModule, 
            InputTextComponent, 
            ToastModule,  
            BlockUIModule,
            ProgressSpinnerModule],
  templateUrl: './edit-organization.component.html',
  styleUrl: './edit-organization.component.scss'
})
export class EditOrganizationComponent {
  blockedDocument = false;
  @Input() visible!: boolean;
  @Output() closeDialog = new EventEmitter();

  organizationForm = new FormGroup({
      name: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(50)])
  });

  _organization!: Organization
  @Input() 
  set organization(value: Organization) {
    this._organization = value;
    if(value) {
      this._organization = value;
      this.organizationForm.patchValue(this.organization);
    }

  }

  get organization() {
    return this._organization;
  }



  constructor(private organizationApi: OrganizationApiService, private messageService: MessageService) {

  }


  close() {
      this.closeDialog.emit("")
  }

  save() {
    if (this.organizationForm.valid) {
     const organization: Organization = this.organizationForm.value as Organization
     this.blockedDocument = true;
     this.organizationApi.updateOrganization(this.organization.id!, organization).subscribe({
        next: (data) =>{
          this.blockedDocument = false;
          this.messageService.add({ severity: 'info', summary: 'Success', detail: 'Organization was succesfully updated.' })
          this.close()
        } ,
        error: (err) => {
          this.blockedDocument = false;
          console.error('Error fetching data', err)
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'A problem occurred during the user update.', life: 5000 })

        }
     })
    } else {
        this.organizationForm.markAllAsTouched();
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please, verify the required fields.', life: 5000 })

    }
  }
}
